import Alert from '@mui/material/Alert'
import Snackbar, { SnackbarProps } from '@mui/material/Snackbar'
import UseAlertReturn from 'src/types/alert/UseAlertReturn'

const ALERT_AUTO_HIDE_DURATION = 6e3

interface SnackbarAlertProps {
  useAlertReturn: Pick<UseAlertReturn, 'alert' | 'close'>
  alignment?: SnackbarProps['anchorOrigin']
}

const SnackbarAlert = ({
  useAlertReturn,
  alignment = { vertical: 'top', horizontal: 'center' },
}: SnackbarAlertProps) => {
  const {
    alert: { open, severity, message },
    close,
  } = useAlertReturn

  return (
    <Snackbar
      anchorOrigin={alignment}
      open={open}
      autoHideDuration={ALERT_AUTO_HIDE_DURATION}
      onClose={close}
    >
      <Alert onClose={close} severity={severity} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  )
}

export default SnackbarAlert
